module.exports = __webpack_public_path__ + "static/media/lobo-guara.29dd6ea7.mp3";